import React from 'react';
import { IArtist } from '../Events/types';
import { ArtistLink, Artwork, Flex } from '../Events/styles';
import { ReactComponent as Icon } from '../../../icons/icon-chevron.svg';
import Box from 'components/elements/Box';
import H1 from '../../elements/h1';
import Button from '../../elements/button';
import { ReactComponent as Close } from '../../../icons/icon-close.svg';
import { TArtist } from '../../../redux/reducers/notificationModals';

const ArtistsOverview: React.FC<IProps> = (props) => {
  const { close, setShowArtistSettings, artists } = props;

  function sortByName(first: IArtist, second: IArtist): number {
    return first.entity.displayName.localeCompare(second.entity.displayName);
  }

  return (
    <Box py={3} px={4}>
      <Button display="block" marginLeft="auto" onClick={close}>
        <Close />
      </Button>
      <H1 fontSize={4} my={0} marginBottom={4}>
        Notification settings — all artists you are subscribed to.
      </H1>
      <ul>
        {artists &&
          artists.sort(sortByName).map((artist: IArtist) => {
            const { id, displayName, thumbnailUrl } = artist.entity;

            return (
              <li key={id}>
                <ArtistLink
                  type="button"
                  onClick={(evt: MouseEvent): void => {
                    evt.stopPropagation();
                    setShowArtistSettings({
                      entityId: id,
                      entityName: displayName,
                    });
                  }}
                >
                  <Flex>
                    <Artwork src={thumbnailUrl} entityType="artist" />
                    <h3>{displayName}</h3>
                  </Flex>
                  <Icon aria-hidden />
                </ArtistLink>
              </li>
            );
          })}
      </ul>
    </Box>
  );
};

interface IProps {
  artists: null | any[];
  close: () => void;
  setShowArtistSettings: (artist: TArtist) => void;
}

export default ArtistsOverview;
